import * as React from "react";

function Cross(props) {
  return <svg viewBox="0 0 24 24" fill="none" {...props}><path d="M5 5l7 7m0 0l7 7m-7-7l7-7m-7 7l-7 7" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" /></svg>;
}

export default Cross;